import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

import { ReactComponent as GatewayIcon } from '@assets/svg/devices/ic-gateway.svg';
import { ReactComponent as MoteIcon } from '@assets/svg/devices/ic-mote.svg';
import { ReactComponent as NodeIcon } from '@assets/svg/devices/ic-node.svg';
import { ReactComponent as RouterIcon } from '@assets/svg/devices/ic-router.svg';
import { ReactComponent as SensorIcon } from '@assets/svg/devices/ic-sensor.svg';
import { ReactComponent as TachometerIcon } from '@assets/svg/devices/ic-tachometer.svg';

import useTranslation from '@hooks/useTranslation';

import type { IActionItem } from '@model/actionItem';

import { getEquipmentType } from '@pages/ActionItem/helpers/getEquipmentType';

import style from './style.module.scss';

interface IProps {
  actionItem: IActionItem;
  deviceId?: number;
}

const Device: React.FC<IProps> = ({ actionItem, deviceId }) => {
  const { t } = useTranslation();
  const { customerId } = useParams();
  const { pathname } = useLocation();

  const { equipment_type } = actionItem;

  const isMote = equipment_type === 'mote';
  const equipmentType = getEquipmentType(
    actionItem.equipment_type,
    actionItem.installation_point?.point_type,
  );
  const typeName = isMote ? 'mote' : equipmentType;

  const renderDevice: { [key: string]: React.ReactElement } = {
    mote: <MoteIcon className={style.deviceIcon} />,
    sensor: <SensorIcon className={style.deviceIcon} />,
    gateway: <GatewayIcon className={style.deviceIcon} />,
    node: <NodeIcon className={style.deviceIcon} />,
    repeater: <RouterIcon className={style.deviceIcon} />,
    tachometer: <TachometerIcon className={style.deviceIcon} />,
  };

  return (
    <div className={style.device}>
      {renderDevice[typeName]}
      <span className={style.deviceType} data-qa={'device-type'}>
        {t(typeName)}
      </span>
      {typeName && deviceId && (
        <Link
          to={`/customer/${customerId}/equipment-details/${equipmentType}/${deviceId}`}
          state={{ prevPage: pathname }}
          data-tooltip-id="ai-details-info"
          data-tooltip-content={t('Go to the Details page')}
          className={style.linkInfo}
        >
          {t(`View details`)}
        </Link>
      )}
    </div>
  );
};

export default Device;
